// extracted by mini-css-extract-plugin
export default {"main":"SearchResults_main__YwHJT","backdrop":"SearchResults_backdrop__GoYUR","hidden":"SearchResults_hidden__YP6U0","spinnerContainer":"SearchResults_spinnerContainer__mPgAn"};